// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import '@styles/tradingplatform/tradingplatform-style.scss';
import './GlobalDeclaration';
import './Extensions';
import { RactiveTooltip } from '@front/controls/misc/Decorators';
import { App } from './Commons/Application';
import { CreateApplicationInfo } from './Commons/CreateApplicationInfo';
import { GlobalAnimationFrameHandler } from './Commons/GlobalAnimationFrameHandler';
import { startRecalculateBalancesLoop } from './Commons/GlobalTimerLoop';
import { tvch } from './Commons/TradingViewDataFeed/Helpers/TvConsoleHelper';
import { TvWorkspaceManager } from './Commons/TradingViewDataFeed/Managers/TvWorkspaceManager';
import { flh } from './Commons/UtilsClasses/FullLogsHelper';
import { ThemeManager } from './Controls/misc/ThemeManager';
import { MainWindowManager } from './Controls/UtilsClasses/MainWindowManager';
import { LOCALE_EN, Resources } from './Localizations/Resources';
import { TradingPlatform } from './TradingPlatform/TradingPlatform';
import { ClientType } from './Utils/ClientType';
export * from './ControlsImport';
export * from '@front/tradingplatform/ControlsImport';
// if (module.hot) {
//     module.hot.accept();
// }
window.addEventListener('load', function () {
    RactiveTooltip.tooltipHandlerInitialize();
    ClientType.setIsTvTradingPlatform();
    CreateApplicationInfo();
    App.InitializeWebtrader();
    App.InitStorages();
    TvWorkspaceManager.initialize();
    ThemeManager.themeChange();
    MainWindowManager.MainWindow = new TradingPlatform();
    GlobalAnimationFrameHandler();
    startRecalculateBalancesLoop();
    Resources.setLocale(LOCALE_EN);
    window.flh = flh;
    window.tvch = tvch;
});
window.addEventListener('contextmenu', function (e) {
    e.preventDefault();
});
